module.exports = __webpack_public_path__ + "static/home1-header-social-icons-df8ef8b0079208ae38dda4f06dc06052.png";